import { message, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { request } from '../../../../utils/request'

type CertificateType = {
  id: number
  org_id: number
  stack: string
  ca_file_name: string
  ca_bundle_str: string
}


export const DownloadModal = (props: { org_id: number, stack: string, onCancel: () => void }) => {
  const { org_id, stack, onCancel } = props
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState<number>()
  const [list, setList] = useState<CertificateType[]>([])

  const downloadFile = () => {
    if(value === undefined) return
    const content = list.find(v => v.id === value)!.ca_bundle_str
    const filename = list.find(v => v.id === value)!.ca_file_name
    const blob = new Blob([content], { type: 'text/plain' });
    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  }


  const getCertificateList = async () => { 
    try {
      const res = await request<undefined, CertificateType[]>(`/dc/portal/api/org/cabundle/list?orgId=${org_id}&stack=${stack}`, { method: 'get' })
      if (res.length <= 0) throw new Error('没有证书')
      setOpen(true)
      setList(res.map(v => ({ ...v, label: v.ca_file_name, value: v.id })))
    } catch (error) {
      message.warning('没有证书')
      onCancel()
    }
  }

  useEffect(() => {
    getCertificateList()
  }, [])


  return <Modal open={open} onCancel={onCancel} title='证书下载' onOk={downloadFile}>
    <Select placeholder='请选择证书' style={{ width: '100%' }} options={list} value={value} onChange={setValue} />
  </Modal>
}